import { Navigate } from "react-router-dom"
import { Routes } from "../states/States"
import { JSX } from "react"
import ErrorPage from "../common/Pages/error"
import LoginScreen from "../components/UI/Login/Login"
import Dashboard from "../common/Pages/Dashboard";
import CreateUser from "../common/Pages/Dashboard/CreateUser";
import EditUser from "../common/Pages/Dashboard/EditUser";
import CreateEv from "../common/Pages/Dashboard/CreateEv";
import NotificationList from "../common/Pages/Notification/NotificationList";
import CreateNotification from "../common/Pages/Notification/CreateNotification";
import EditNotification from "../common/Pages/Notification/EditNotification";
import Ridertrack from "../common/Pages/Dashboard/Ridertrack";
import Overview from "../common/Pages/Dashboard/OverView";
import UserDetails from "../common/Pages/Dashboard/UserDetails";
import EvDetails from "../common/Pages/Dashboard/EvDetails";
import IotDetails from "../common/Pages/Dashboard/IotDetails";
import RideEndRequest from "../common/Pages/Dashboard/RideEndRequest";
import PaymentDetails from "../common/Pages/Dashboard/PaymentDetails";
import WalletDeduction from "../common/Pages/Dashboard/WalletDeduction";
import RideEnded from "../common/Pages/Dashboard/RideEnded";
import ReadyAllotment from "../common/Pages/Dashboard/ReadyAllotment";
import Reports from "../common/Pages/Dashboard/Reports";
import EvPlans from "../common/Pages/Dashboard/EvPlans";
import CreatePlan from "../common/Pages/Dashboard/CreatePlan";





const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const isAuthenticated = localStorage.getItem("token")
    if (!isAuthenticated) {
        return <Navigate to="/" replace />
    }
    return children
}

const CommonRoutes: Array<Routes> = [
    {
        path: "/",
        element: <LoginScreen />,
    },
    { path: "*",
      element: (
      <ErrorPage/>
     )
      },
    {
        path: "/dashboard",
        element: (
          <RequireAuth>
             <Dashboard />
          </RequireAuth>
        ),
      },
      {
        path: "/createUser",
        element: (
          <RequireAuth>
            <CreateUser />
          </RequireAuth>
        ),
      },
      {
        path: "/createEv",
        element: (
          <RequireAuth>
            <CreateEv />
          </RequireAuth>
        ),
      },
      {
        path: "/notificationList",
        element: (
          <RequireAuth>
            <NotificationList />
          </RequireAuth>
        ),
      },
      {
        path: "/createNotification",
        element: (
          <RequireAuth>
              <CreateNotification />
          </RequireAuth>
        ),
      },
      {
        path: "/editUser",
        element: (
          <RequireAuth>
               <EditUser />
          </RequireAuth>
        ),
      },
      { path: "/editNotification*",
        element: (
        <RequireAuth><EditNotification/></RequireAuth> 
       )
        },
        { path: "/ridertrack*",
          element: (
          <RequireAuth><Ridertrack/></RequireAuth> 
         )
          },
          { path: "/overview",
          element: (
           <RequireAuth><Overview/></RequireAuth>
         )
          },
          { path: "/userdetails",
          element: (
          <RequireAuth><UserDetails/></RequireAuth>
         )
          },
          { path: "/evdetails/ev-details-list",
          element: (
           <RequireAuth><EvDetails/></RequireAuth>
         )
          },
       
          { path: "/iotdetails",
          element: (
           <RequireAuth><IotDetails/></RequireAuth>
         )
          },
           { path: "/rideendrequest",
          element: (
           <RequireAuth><RideEndRequest/></RequireAuth> 
         )
          },
          { path: "/paymentdetails",
          element: (
           <RequireAuth><PaymentDetails/></RequireAuth> 
          )
          },
          { path: "/walletDeduction",
          element: (
           <RequireAuth><WalletDeduction/></RequireAuth>
         )
          },
           { path: "/evdetails/ride-ended",
          element: (
           <RequireAuth><RideEnded/></RequireAuth> 
         )
          },
           { path: "/evdetails/ready-for-allotment",
          element: (
           <RequireAuth><ReadyAllotment/></RequireAuth>
         )
          },
          { path: "/reports",
          element: (
           <RequireAuth><Reports/></RequireAuth>
         )
          },
          { path: "/evplans",
          element: (
           <RequireAuth><EvPlans/></RequireAuth>
         )
          },
          { path: "/evplans/create",
          element: (
           <RequireAuth><CreatePlan/></RequireAuth>
         )
          }

]

export const Router: Array<Routes> = [
    ...CommonRoutes,
    /**
     *@description
     * Url to Embeded in Iframe
     *
     */
    // {
    //   path: "", // test route
    //   element: <Header />,
    //   children: [
    //     ...CommonRoutes,
    //     {
    //       path: "*", // test route
    //       element: <div>NOT FOUND</div>,
    //     },
    //   ],
    // },
]
